import { Component, OnInit } from '@angular/core'
import { UserAnalyticEvents } from '../../../models/event-collector.model'
import { GrowthBookFactoryService } from '../../../services/growthbook-factory.service'
import { isScullyRunning } from '@scullyio/ng-lib'
@Component({
  selector: 'flowaccount-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrl: './contact-support.component.scss',
})
export class ContactSupportComponent implements OnInit {
  public contactDetails = [
    {
      icon: 'fas fa-envelope',
      info: 'support@flowaccount.com',
      target: '_top',
      link: 'mailto:support@flowaccount.com',
      key: 'ContactEmail',
    },
    { icon: 'fas fa-phone', info: '02-026-8989', target: '_self', link: 'tel:020268989' },
  ]
  public chatLinks = [
    {
      class: 'chat-messenger',
      link: 'https://m.me/1395566264070503',
      image: 'https://flowaccountcdn.com/new_landing/image/massenger_logo.svg',
      key: 'ContactPhone',
    },
    {
      class: 'chat-line',
      link: 'https://page.line.me/flowaccount?openQrModal=true',
      image: 'https://flowaccountcdn.com/new_landing/image/line_logo.svg',
    },
  ]
  public skeletonCustomCount = {
    subheading: 0,
    heading: 2,
    detail: 5,
    btn: 0,
  }
  public isSkeletonLoading = true
  public UserAnalyticEvents = UserAnalyticEvents

  constructor(private growthBookFactoryService: GrowthBookFactoryService) {}

  ngOnInit() {
    this.isSkeletonLoading = isScullyRunning()
  }

  trackGrowthBookMetric(eventId: UserAnalyticEvents, dataName: string) {
    this.growthBookFactoryService.trackEvent(eventId, dataName)
  }
}
